<template>
  <div class="wrap-dashboard">
    <div class="main-content">
      <div class="wrap-content">
        <div class="title-page">Role</div>
        <div class="content">
          <button type="button" class="btn btn-light" v-b-modal.modal-1>Add</button>
          <table>
            <thead>
              <tr id="top">
                <th scope="col">No</th>
                <th scope="col">Name</th>
                <th scope="col">Role</th>
                <!-- <th scope="col">Action</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, i) in usersData" :key="i">
                <td data-label="No">{{ i + 1 }}</td>
                <td data-label="Name">{{ user.name }}</td>
                <td data-label="Role">{{ user.role_id }}</td>
                <!-- <td data-label="Action">
                  <button type="button" class="btn btn-outline-warning btn-sm">Edit</button>
                </td> -->
              </tr>
            </tbody>
          </table>
          <!-- <b-pagination
            v-model="currentPage"
            :total-rows="lengthData"
            :per-page="perPage"
            @change="handlePageChange"
            aria-controls="new-table"
            first-number
            last-number
            v-show="lengthData > 10"
          ></b-pagination> -->
        </div>
        <b-modal id="modal-1" title="ADD Role" @ok="handleOk">
          <form>
            <div class="form-group">
              <label for="">Name</label>
              <input type="text" placeholder="input Name" class="form-input" v-model="formAddRole.name" />
            </div>
          </form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      usersData: [],
      pageOfItems: [],
      currentPage: 1,
      perPage: 10,
      lengthData: 1,
      trade_id: [],
      offset: 0,
      data: [],
      form: {
        startDate: "",
        endDate: "",
      },
      formAddRole: {
        name: "",
      },
      roles: [],
    };
  },
  mounted() {
    this.getData(this.currentPage);
    axios.post("/v2/management/role/all").then((res) => {
      this.roles = res.data.data.roles;
    });
  },
  methods: {
    handleOk(bvModal) {
      console.log(bvModal);
      axios.post("/v2/management/role", this.formAddRole).then((res) => {
        if (res.data.data.status_code == "00") {
          console.log(res);
          // location.reload();
        }
      });
    },
    handlePageChange(value) {
      this.getData(value);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    filterDate() {
      axios
        .get(
          "https://api2-dev.abicommodity.co.id/v1/counter/get/customer/transaction?offset=&limit=&startDate=" + this.form.startDate + "&endDate=" + this.form.endDate
        )
        .then((res) => {
          this.data = res.data.data.data;
          this.lengthData = res.data.data.count;
          for (let i = 0; i < this.data.length; i++) {
            let trade;
            let tradeSell;
            trade = this.data[i].direction[0].trade_id;
            tradeSell = this.data[i].direction[1].trade_id;
            if (trade && tradeSell) {
              this.data[i].direction[0].tradebuy = trade.split(";");
              this.data[i].direction[1].tradeSell = tradeSell.split(";");
            } else {
              this.data[i].direction[0].tradebuy = "";
              this.data[i].direction[1].tradeSell = "";
            }
          }
        });
    },
    getData(value) {
      let offset = (value - 1) * this.perPage;
      console.log(offset);
      axios.get("v2/management/role/all").then((res) => {
        console.log(res);
        this.usersData = res.data.data.roles;
        // this.lengthData = res.data.data.count;
      });
    },
  },
  computed: {
    rows() {
      return (this.currentPage - 1) * this.perPage;
    },
  },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.title-page {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 40px;
}

.wrap-content {
  width: 98%;
  height: 100%;
  margin: 0 auto;
  padding: 20px 25px;
}

.content {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: end;
}

.icon-trade {
  width: 25px;
}

.footer {
  background: var(--clr-primary);
  color: white;
  padding: 20px 47px;
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  height: 62px;
}

.filter {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 12px;
  flex-wrap: wrap;
}

.wrap-input {
  margin-bottom: 10px;
}
.label-input {
  width: 108px;
}

.input-datalist {
  border-radius: 3px;
  border: 1px solid #a5a5a5a5;
  padding: 1.5px 5px;
}

.card {
  width: 314px;
  font-size: 14px;
  border-radius: 10px;
}

.card-header {
  padding: 1rem;
}

.buyer,
.seller,
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 12px;
  position: relative;
  left: 20px;
}

.title::before {
  content: "";
  position: absolute;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--clr-scondary);
  left: -17px;
  top: 3px;
}

.buyer {
  margin-bottom: 20px;
}

.content-right {
  text-align: right;
}

.amount {
  font-weight: bold;
}

.btn-primer {
  background: var(--clr-scondary);
  border: none;
  color: #ffffff;
  padding: 5px 25px;
  border-radius: 5px;
}

.btn-primer:hover {
  background-color: var(--clr-scondary-hover);
}

.form-group label {
  font-weight: 600;
  width: 30%;
}

.form-input {
  width: 70%;
  border-radius: 5px;
  border: none;
  padding: 8px 13px;
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
  font-size: 14px;
}

.form-input:focus {
  border-color: var(--clr-primary);
  outline: 0;
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}
</style>
